import { logOutAndFlush } from 'serviceWorker/services/logout';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { logoutContract } from 'shared/domain/logout/logoutContract';

/** Answers the page's sign out requests. */
export function serveLogoutRequests(): ChannelUnsubscribe {
  return channelServer.handle(logoutContract, { logout: logOutAndFlush });
}
